import React from 'react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <section className="bg-navy-900 text-cream-100 py-24 px-6 relative" data-id="element-75">
      {/* Decorative background lines */}
      <div className="absolute top-0 right-0 opacity-10 pointer-events-none w-1/2 h-full" data-id="element-76">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-77">
          <path d="M50,0 Q80,50 50,100" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-78" />
          <path d="M60,0 Q90,50 60,100" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-79" />
          <path d="M70,0 Q100,50 70,100" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-80" />
        </svg>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-82">
          <span className="text-gold-500 font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-83">
            The Unique Mechanism
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-12" data-id="element-84">
            The{' '}
            <span className="text-gold-500 italic" data-id="element-85">Nervous System Flush</span>
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-cream-200 font-light leading-relaxed text-left max-w-3xl mx-auto" data-id="element-86">
            <p data-id="element-87">
              The secret lies in the{' '}
              <strong className="text-gold-400 font-medium" data-id="element-88">
                Nervous System Flush
              </strong>
              . Your body has a physical drainage system called the{' '}
              <strong className="text-gold-400 font-medium" data-id="element-89">
                Lymphatic System
              </strong>
              .
            </p>

            <p data-id="element-90">
              When you are chronically stressed, this "plumbing" becomes
              stagnant, trapping stress hormones in your tissues.
            </p>

            <div className="bg-navy-800/80 border-l-4 border-gold-500 p-8 rounded-r-xl my-10" data-id="element-91">
              <p className="text-cream-50" data-id="element-92">
                The Cortisol Reset Protocol uses a 4-minute{' '}
                <strong className="text-gold-400 font-medium" data-id="element-93">
                  Somatic Flush
                </strong>{' '}
                to manually drain these chemicals, combined with{' '}
                <strong className="text-gold-400 font-medium" data-id="element-94">
                  Micro-Nutrition Silencing
                </strong>
                —a specific mineral "cocktail"—to chemically mute the adrenal
                alarm.
              </p>
            </div>

            <p className="text-center text-2xl font-serif text-cream-50 pt-4" data-id="element-95">
              We fix the plumbing so your brain can finally find the "Off"
              switch.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}